<template>
    <div>
        <CRow>
            <CCol md="12">
                <CCard>
                    <CCardHeader>
                        <strong>{{$t('components.complimentaryList')}}</strong>
                    </CCardHeader>
                    <CCardBody>
                        <CRow>

                            <CCol col="3">
                                <date-picker
                                        :label="$t('components.startDate')"
                                        v-model="start_date"></date-picker>
                            </CCol>
                            <CCol col="3">
                                <date-picker
                                        :label="$t('components.endDate')"
                                        v-model="end_date"></date-picker>
                            </CCol>
                            <CCol col="1">
                                <CButton @click="get_lists_1" color="dark"
                                         size="sm">
                                    <CIcon size="sm" name="cil-zoom"/>
                                </CButton>
                            </CCol>
                        </CRow>
                      <CDataTable
                          :items="items1"
                          :fields="fields_list"

                          :items-per-page="20"
                          hover
                          sorter
                          :sorter-value="{column:'recId',asc:false}"
                          pagination
                      >
                        <template #row="{item,index}">
                          <td>
                            <p>{{index+1}}</p>
                          </td>
                        </template>
                        <template #eshantionStart="{item}">
                          <td>
                            <p>
                               {{get_date(item.eshantionStart)}}
                            </p>
                          </td>
                        </template>
                        <template #eshantionEnd="{item}">
                          <td>
                            <p>
                              {{get_date(item.eshantionEnd)}}
                            </p>
                          </td>
                        </template>


                        <template #status="{item}">
                          <td>
                            <p>
                              <CBadge v-if="new Date() > new Date(item.eshantionEnd)"  color="danger">{{$t('components.finished')}}</CBadge>
                              <CBadge v-if="item.isActive==0" color="danger">{{ $t('components.statusOff') }}</CBadge>
                              <CBadge v-if="new Date() <= new Date(item.eshantionEnd) && item.isActive==1" color="success">{{$t('components.statusOn') }}</CBadge>
                            </p>
                          </td>
                        </template>

                        <template #operation="{item,index}">
                          <td>
                            <CButton class="m-1"
                                     color="primary"
                                     variant="outline"
                                     :title="$t('buttons.edit')"
                                     square
                                     size="sm"
                                     @click="edit_master(item)"
                            >
                              <CIcon size="sm" name="cil-pencil"/>
                            </CButton>

                            <CButton class="m-1"
                                     color="primary"
                                     variant="outline"
                                     :title="$t('buttons.edit')"
                                     square
                                     size="sm"
                                     @click="show_detail_item = item,show_detail_dialog=true"
                            >
                              <CIcon size="sm" name="cil-list"/>
                            </CButton>
                          </td>
                        </template>

                      </CDataTable>

                    </CCardBody>
                </CCard>
            </CCol>
        </CRow>
        <CModal
                :show.sync="edit_master_dialog"
                :no-close-on-backdrop="true"
                :centered="true"
                :title="$t('edit')"
                size="lg"
                color="dark"
        >
            <CCard>
                <CCardHeader>
                    <strong>{{ $t('buttons.edit') }}</strong>

                </CCardHeader>
                <CCardBody>
                    <CRow>

                        <CCol col="6">
                            <CSelect
                                    :options="[{label:$i18n.t('active'),value:1},{label:$i18n.t('deactivate'),value:0}]"
                                    :value.sync="edit_master_status"
                            />
                        </CCol>
                        <CCol  col="6">
                            <CInput
                                    :label="$t('title')"
                                    v-model="edit_master_title"
                                    horizontal
                            />
                        </CCol>

                        <CCol  col="6">
                            <date-picker
                                    horizontal
                                    v-model="edit_master_start_date"
                                    :label="$t('components.startDate')"
                            ></date-picker>
                        </CCol>
                        <CCol  col="6">
                            <date-picker
                                    horizontal
                                    v-model="edit_master_end_date"

                                    :label="$t('components.endDate')"
                            ></date-picker>

                        </CCol>

                    </CRow>

                </CCardBody>

            </CCard>


            <template #footer>
                <CButton
                        @click="edit_master_dialog = false"
                        color="danger"
                >{{ $t("buttons.close") }}
                </CButton>
                <CButton
                        @click="update_master()"
                        color="success"
                >{{ $t("buttons.ok") }}
                </CButton>
            </template>
        </CModal>

        <CModal
                :show.sync="edit_detail_dialog"
                :no-close-on-backdrop="true"
                :centered="true"
                :title="$t('edit')"
                size="lg"
                color="dark"
        >
            <CCard>
                <CCardHeader>
                    <strong>{{ $t('buttons.edit') }}</strong>

                </CCardHeader>
                <CCardBody>
                    <CRow class="m-0" >

                        <CCol col="4">
                            <CSelect v-if="get_access('customer_type')"
                                     :label="$t('GuildType')"

                                     :value.sync="edit_detail_product_info.guildUnitId"
                                     :options="guild_items"
                            />
                        </CCol>

                        <CCol  col="4">
                            <label>{{$t('components.firstProduct')}}</label>
                            <treeselect
                                    v-model="edit_detail_product_info.firstProductId"
                                    :async="async_product"
                                    :options="temp_products"
                                    :load-options="load_products"
                                    :placeholder="$t('components.searchProduct')"
                                    :normalizer="normalizer_products"
                            />
                        </CCol>
                        <CCol col="4" >

                            <CInput
                                    :label="$t('components.firstProductQty')"
                                    type="number"
                                    v-on:keypress="isNumber($event)"
                                    v-model="edit_detail_product_info.qty"
                            />
                        </CCol>
                        <CCol col="4" >

                            <CInput
                                    :label="$t('components.off')"
                                    type="number"
                                    v-on:keypress="isNumber($event)"
                                    v-model="edit_detail_product_info.takhfif"
                            />
                        </CCol>
                        <CCol  col="4">
                            <label>{{$t('components.secondProduct')}}</label>

                            <treeselect
                                    v-model="edit_detail_product_info.resultProductId"
                                    :options="temp_products"

                                    :async="async_product"
                                    :load-options="load_products"
                                    :placeholder="$t('components.searchProduct')"
                                    :normalizer="normalizer_products"
                            />

                        </CCol>

                        <CCol  col="4">

                            <CInput
                                    :label="$t('components.secondProductQty')"
                                    type="number"
                                    v-on:keypress="isNumber($event)"
                                    v-model="edit_detail_product_info.resultQty"
                            />
                        </CCol>
                    </CRow>

                </CCardBody>

            </CCard>


            <template #footer>
                <CButton
                        @click="edit_detail_dialog = false"
                        color="danger"
                >{{ $t("buttons.close") }}
                </CButton>
                <CButton
                        @click="update_detail_product()"
                        color="success"
                >{{ $t("buttons.ok") }}
                </CButton>
            </template>
        </CModal>
        <CModal
                :show.sync="show_detail_dialog"
                :no-close-on-backdrop="true"
                :centered="true"
                :title="$t('show')"
                size="lg"
                color="dark"
        >
          <CCardBody v-if="show_detail_item.details!=null">
            <div v-if="show_detail_item.details.filter(x=>x.typeId ==2).length">
              {{$t('tables.complimentary')}}
              <CDataTable
                  :items="show_detail_item.details.filter(x=>x.typeId ==2)"
                  :fields="fields_complimentary"

                  :items-per-page="20"
                  hover
                  sorter
                  :sorter-value="{column:'recId',asc:false}"
                  pagination
              >
                <template #row="{item}">

                  <td>
                    <p>{{item.row_id+1}}</p>

                  </td>

                </template>
                <template #createdAt="{item}">

                  <td>
                    <p>{{item.createdAt}}</p>

                  </td>

                </template>
                <template #startDate="{item}">
                  <td>
                    <p>{{get_date(item.startDate)}}</p>
                  </td>
                </template>
                <template #endDate="{item}">
                  <td>
                    <p>{{get_date(item.endDate)}}</p>
                  </td>
                </template>
                <template #warehouse="{item}">
                  <td>
                    <p>{{item.placeName}}</p>

                  </td>

                </template>
                <template #amount="{item}">

                  <td>
                    <p>{{item.totalPrice}}</p>

                  </td>


                </template>
                <template #customer="{item}">

                  <td>
                    <p>{{item.partyName}}</p>

                  </td>

                </template>
                <template #toziKonande="{item}">

                  <td>
                    <p v-if="item.toziKonande!=null">{{item.toziKonande}}</p>

                  </td>

                </template>
                <template #user="{item}">

                  <td>
                    <p>{{item.createdBy}}</p>

                  </td>

                </template>


                <template #operation="{item,index}">
                  <td>
                    <CButton class="m-1"
                             color="primary"
                             variant="outline"
                             :title="$t('buttons.edit')"
                             square
                             size="sm"
                             @click="edit_detail_product(item)"
                    >
                      <CIcon name="cil-pencil"/>
                    </CButton>
                  </td>
                </template>

                <template #select="{item}">
                  <td>

                    <CCol v-if="item.statusId !=0 && item.toziKonande==null">

                      <input type="checkbox" ref="permissions[]" v-model="id_checkbox_items"
                             :value="item.recId"/>

                    </CCol>

                  </td>
                </template>
              </CDataTable>
            </div>
            <hr>
            <div v-if="show_detail_item.details.filter(x=>x.typeId ==3).length">

              {{$t('itemDiscount')}}

              <CDataTable
                  :items="show_detail_item.details.filter(x=>x.typeId ==3)"
                  :fields="fields_off"

                  :items-per-page="20"
                  hover
                  sorter
                  pagination
              >
                <template #row="{item}">

                  <td>
                    <p>{{item.row_id+1}}</p>

                  </td>

                </template>
                <template #createdAt="{item}">

                  <td>
                    <p>{{item.createdAt}}</p>

                  </td>

                </template>
                <template #startDate="{item}">
                  <td>
                    <p>{{get_date(item.startDate)}}</p>
                  </td>
                </template>
                <template #endDate="{item}">
                  <td>
                    <p>{{get_date(item.endDate)}}</p>
                  </td>
                </template>
                <template #warehouse="{item}">
                  <td>
                    <p>{{item.placeName}}</p>

                  </td>

                </template>
                <template #amount="{item}">

                  <td>
                    <p>{{item.totalPrice}}</p>

                  </td>


                </template>
                <template #customer="{item}">

                  <td>
                    <p>{{item.partyName}}</p>

                  </td>

                </template>
                <template #toziKonande="{item}">

                  <td>
                    <p v-if="item.toziKonande!=null">{{item.toziKonande}}</p>

                  </td>

                </template>
                <template #user="{item}">

                  <td>
                    <p>{{item.createdBy}}</p>

                  </td>

                </template>


                <template #operation="{item,index}">
                  <td>

                    <CButton class="m-1"
                             color="danger"
                             variant="outline"
                             :title="$t('buttons.delete')"
                             square
                             size="sm"
                             @click="delete_item_dialog(item)"
                    >
                      <CIcon name="cilTrash"/>
                    </CButton>

                  </td>
                </template>


              </CDataTable>
            </div>
            <hr>
            <div v-if="show_detail_item.details.filter(x=>x.typeId ==1).length">

              {{$t('GeneralDiscount')}}
              <CDataTable
                  :items="show_detail_item.details.filter(x=>x.typeId ==1)"
                  :fields="fields_off_code"

                  :items-per-page="20"
                  hover
                  sorter
                  pagination
              >
                <template #row="{item,index}">
                  <td>
                    <p>{{index+1}}</p>
                  </td>
                </template>
                <template #personTypeTitle="{item}">
                  <td>
                    <p v-if="item.personType!=0">{{item.personTypeTitle}}</p>
                    <p v-else>{{$t('SpecificCustomer')}}</p>
                  </td>
                </template>
                <template #personName="{item}">
                  <td>
                    <p v-if="item.personType!=0">{{item.provinceTitle}} - {{item.cityTitle}}</p>
                    <p v-else>{{item.personName}}</p>
                  </td>
                </template>
                <template #createdAt="{item}">

                  <td>
                    <p>{{item.createdAt}}</p>

                  </td>

                </template>

                <template #warehouse="{item}">
                  <td>
                    <p>{{item.placeName}}</p>

                  </td>

                </template>
                <template #amount="{item}">

                  <td>
                    <p>{{item.totalPrice}}</p>

                  </td>


                </template>
                <template #customer="{item}">

                  <td>
                    <p>{{item.partyName}}</p>

                  </td>

                </template>
                <template #toziKonande="{item}">

                  <td>
                    <p v-if="item.toziKonande!=null">{{item.toziKonande}}</p>

                  </td>

                </template>
                <template #user="{item}">
                  <td>
                    <p>{{item.createdBy}}</p>
                  </td>
                </template>
                <template #startDate="{item}">
                  <td>
                    <p>{{get_date(item.startDate)}}</p>
                  </td>
                </template>
                <template #endDate="{item}">
                  <td>
                    <p>{{get_date(item.endDate)}}</p>
                  </td>
                </template>


                <template #operation="{item,index}">
                  <td>
                    <CButton class="m-1"
                             color="danger"
                             variant="outline"
                             :title="$t('buttons.delete')"
                             square
                             size="sm"
                             @click="delete_item_dialog(item)"
                    >
                      <CIcon name="cilTrash"/>
                    </CButton>
                  </td>
                </template>

              </CDataTable>
            </div>
          </CCardBody>

            <template #footer>
                <CButton
                        @click="show_detail_dialog = false"
                        color="danger"
                >{{ $t("buttons.close") }}
                </CButton>

            </template>
        </CModal>

    </div>
</template>

<script>
    import axios from "axios";
    import {bus} from '../../../main';
    import Treeselect from '@riophae/vue-treeselect'
    // import the styles
    import '@riophae/vue-treeselect/dist/vue-treeselect.css'
    import Vue from "vue";

    import {ASYNC_SEARCH} from '@riophae/vue-treeselect'
    import BTab from "../../tabs/BTab";
    import BTabs from "../../tabs/BTabs";

    var simulateAsync = null
    const simulateAsyncOperation = fn => {
        if (simulateAsync != null) {
            clearTimeout(simulateAsync)
        }
        simulateAsync = setTimeout(fn, 1000)
    }
    var items = [];


    export default {
        name: 'EshantionList',
        components: {
            BTabs,
            BTab,
            Treeselect,

        },
        data() {
            return {

                selected_guild: 0,

                selected_type_item: 0,
                type_items: [],
                temp_products: [],
                async_product:true,
              show_detail_dialog:false,
              show_detail_item:{},

                festival_detail: [{}],

                name: '',
                file: '',
                color: '#ffffff',
                previewImage: '',
                description: '',
                items1: items.map((item, row_id) => {
                    return {...item, row_id}


                }), items2: items.map((item, row_id) => {
                    return {...item, row_id}


                }), items3: items.map((item, row_id) => {
                    return {...item, row_id}


                }),
              fields_list: [
                {key: 'row',label:this.$t('tables.sharp'), _style: 'width:10%'},


                    {key: 'eshantionTitle', label: this.$t('components.title'), _style: 'width:10%'},
                    {key: 'eshantionStart', label: this.$t('components.startDate'), _style: 'width:20%;'},
                    {key: 'eshantionEnd', label: this.$t('components.endDate'), _style: 'width:20%;'},
                    {key: 'status', label: this.$t('components.status'), _style: 'width:20%;'},
                 {key: 'operation', label: "", _style: 'width:10%;'},
                    // {key: 'startDate', label: this.$t('startDate'), _style: 'width:20%'},
                    // {key: 'endDate', label: this.$t('endDate'), _style: 'width:20%'},


                ], fields_off_code: [
                {key: 'row',label:this.$t('tables.sharp'), _style: 'width:10%'},

                    {key: 'personTypeTitle', label: this.$t('tables.type'), _style: 'width:10%'},
                    {key: 'personName', label: this.$t('components.customer'), _style: 'width:20%;'},

                    {key: 'takhfif', label: this.$t('tables.off'), _style: 'width:10%'},
                    {key: 'operation', label: "", _style: 'width:10%;'},
                    // {key: 'startDate', label: this.$t('startDate'), _style: 'width:20%'},
                    // {key: 'endDate', label: this.$t('endDate'), _style: 'width:20%'},


                ],
              fields_complimentary: [
                    {key: 'firstProductName', label: this.$t('tables.firstProduct'), _style: 'width:15%'},
                    {key: 'firstUnitTitle', label: this.$t('tables.unit'), _style: 'width:10%'},
                    {key: 'qty', label: this.$t('tables.qty'), _style: 'width:5%'},
                    {key: 'takhfif', label: this.$t('tables.offPercent'), _style: 'width:5%'},
                    {key: 'resultProductName', label: this.$t('tables.complimentaryProducts'), _style: 'width:15%'},
                    {key: 'resultUnitTitle', label: this.$t('tables.unit'), _style: 'width:15%'},
                    {key: 'resultQty', label: this.$t('tables.qty'), _style: 'width:5%'},
                    // {key: 'startDate', label: this.$t('startDate'), _style: 'width:20%'},
                    // {key: 'endDate', label: this.$t('endDate'), _style: 'width:20%'},


                    {key: 'operation', label: "", _style: 'width:5%;'},


                ],
              fields_off: [
                    {key: 'row', _style: 'width:10%'},
                    {key: 'price', label: this.$t('tables.amount'), _style: 'width:10%'},
                    {key: 'takhfif', label: this.$t('tables.offPercent'), _style: 'width:20%'},
                    {key: 'startDate', label: this.$t('startDate'), _style: 'width:20%'},
                    {key: 'endDate', label: this.$t('endDate'), _style: 'width:20%'},
                    {key: 'operation', label: this.$t('tables.operation'), _style: 'width:20%;'},

                ],

                details: [],
                collapseDuration: 0,
                status_form: 0,


                min_price: '',
                min_percent: '',

                start_date: '',
                end_date: '',


                unit_items: [],

                unit_items_filtered1: [],
                selected_place1: 0,
                selected_product1: null,

                unit_items_filtered2: [],
                selected_place2: 0,
                selected_product2: null,
                product_description: '',
                product_description_off: '',

                province_items: [],
                selected_province: 0,


                country_items: [],
                selected_country: 0,
                selected_master:0,
                edit_master_dialog:false,
                edit_master_status:0,
                edit_master_title:'',
                edit_master_start_date:'',
                edit_master_end_date:'',
                city_items: [],
                guild_items: [],

                selected_city: 0,
                edit_detail_dialog:false,
edit_detail_product_info:{},
                load_products({action, searchQuery, callback}) {
                    var self = this;

                    if (action === ASYNC_SEARCH) {
                        simulateAsyncOperation(() => {
                            let options;
                            const formData = new FormData();

                            formData.append('SearchTxt', searchQuery);

                            axios.post('GetProducts', formData, {show_pros: true}).then(function (response) {
                                options = response.data.data;

                                callback(null, options);

                                // localStorage.setItem("api_token", response.data.access_token);
                                // self.$router.push({ path: 'notes' });
                            })
                                .catch(function (error) {

                                    console.log(error);
                                });


                            //  const options = this.get_keywords(searchQuery);
                            // const options = [1, 2, 3, 4, 5].map(i => ({
                            //     id: `${searchQuery}-${i}`,
                            //     name: `${searchQuery}-${i}`,
                            // }))

                        })
                    }
                },
                normalizer_products(node) {
                    return {
                        id: node.id,
                        label: node.productCodeName,
                    }
                },

            }
        },
        mounted() {
            this.$root.root_validate_errors = [];
            this.start_date = this.get_day_before_today_in_day(1);
            this.end_date = this.get_today();

            this.get_lists_1();
            this.get_guild_types();
            // this.get_lists_2();
            // this.get_lists_3();

            // this.get_lists();
            bus.$on(this.confirm_delete_name, (data) => {
                // alert(data);
                if (data == "true") {
                    this.delete_item();

                } else {
                    this.status_form = 0;
                }
            });
        }, watch: {},
        methods: {
            edit_master(item){

              this.selected_master= item.id
                this.edit_master_status=item.isActive
                this.edit_master_title=item.eshantionTitle
                this.edit_master_start_date=item.eshantionStart
                this.edit_master_end_date=item.eshantionEnd
                this.edit_master_dialog = true
            },
            edit_detail_product(item){
var self = this;
              this.edit_detail_product_info= item
                this.async_product = false

                this.temp_products.push({id:item.resultProductId,productCodeName:item.resultProductName})
                this.temp_products.push({id:item.firstProductId,productCodeName:item.firstProductName})

                setTimeout(function () {
                    self.async_product = true;
                },500)

                this.edit_detail_dialog = true
            },
            get_lists_1() {
                var self = this;


                const formData = new FormData();
                var url = "GetEshantionMasters";

                formData.append("FromDate", this.start_date)
                formData.append("ToDate", this.end_date)

                axios.post(url, formData, {}).then(function (response) {

                    var content_data = response.data;

                    // items = content_cats.orders;
                    if (content_data.statusCode == 0) {
                        self.items1 = content_data.data.map((item, row_id) => {
                            return {...item, row_id}
                        });

                        console.log("items1 ", JSON.stringify(self.items1));
                        //     self.templates_items = content_data.data;

                    } else {
                        self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

                    }

                })
                    .catch(function (error) {

                        console.log(error);
                    });

            },
            update_master() {
                var self = this;


                const formData = new FormData();
                var url =  "EditEshantionMaster";
                formData.append('id', this.selected_master)


                formData.append("EshantionEnd", this.edit_master_end_date);
                formData.append("EshantionStart", this.edit_master_start_date);
                formData.append("EshantionTitle", this.edit_master_title);
                formData.append("IsActive", this.edit_master_status);



                axios.post(url, formData, {}).then(function (response) {

                    var content_data = response.data;

                    // items = content_cats.orders;
                    if (content_data.statusCode == 0) {
                        self.edit_master_dialog = false
                        self.get_lists_1();

                        //     self.templates_items = content_data.data;

                    } else {
                        self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

                    }

                })
                    .catch(function (error) {

                        console.log(error);
                    });

            },
            update_detail_product() {
                var self = this;


                const formData = new FormData();
                var url =  "EditEshantion";
                formData.append('id', this.edit_detail_product_info.id)

                formData.append("EshantionType", 2);
                formData.append("Takhfif", this.edit_detail_product_info.takhfif);
                formData.append("FirstProductId", this.edit_detail_product_info.firstProductId);
                formData.append("Qty", this.edit_detail_product_info.qty);
                formData.append("ResultProductId", this.edit_detail_product_info.resultProductId);
                formData.append("ResultQty", this.edit_detail_product_info.resultQty);
                formData.append("GuildUnitId", this.edit_detail_product_info.guildUnitId);


                axios.post(url, formData, {}).then(function (response) {

                    var content_data = response.data;

                    // items = content_cats.orders;
                    if (content_data.statusCode == 0) {
                        self.edit_detail_dialog = false
                        self.get_lists_1();

                    } else {
                        self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

                    }

                })
                    .catch(function (error) {

                        console.log(error);
                    });

            },
            get_guild_types() {
                var self = this;


                const formData = new FormData();

                axios.post('GuildUnitTitle/GetData', formData, {}).then(function (response) {

                    var content_data = response.data;

                    // items = content_cats.orders;
                    if (content_data.statusCode == 0) {
                        // self.items =  content_data.data.map((item, row_id) => { return {...item, row_id}}),
                        //         fields;


                        self.guild_items = [{label:self.$t('all'),value:0}];
                        self.guild_items = self.sort_array(
                            self.guild_items, content_data.data,
                            'id', 'title');


                    } else {
                        self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

                    }


                })
                    .catch(function (error) {

                        console.log(error);
                    });

            },

        }
    }

</script>
